// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminModalController from "./admin_modal_controller"
application.register("admin-modal", AdminModalController)

import ApiTokensGridController from "./api_tokens_grid_controller"
application.register("api-tokens-grid", ApiTokensGridController)

import AutoDownloadController from "./auto_download_controller"
application.register("auto-download", AutoDownloadController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BookContentsGridController from "./book_contents_grid_controller"
application.register("book-contents-grid", BookContentsGridController)

import BookViewController from "./book_view_controller"
application.register("book-view", BookViewController)

import BooksEntranceController from "./books_entrance_controller"
application.register("books-entrance", BooksEntranceController)

import BooksGridController from "./books_grid_controller"
application.register("books-grid", BooksGridController)

import BulkOperationsController from "./bulk_operations_controller"
application.register("bulk-operations", BulkOperationsController)

import ContentTooltipController from "./content_tooltip_controller"
application.register("content-tooltip", ContentTooltipController)

import ContentBrowserController from "./content_browser_controller"
application.register("content-browser", ContentBrowserController)

import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)

import ExportListenerController from "./export_listener_controller"
application.register("export-listener", ExportListenerController)

import ExportsGridController from "./exports_grid_controller"
application.register("exports-grid", ExportsGridController)

import FavoritesGridController from "./favorites_grid_controller"
application.register("favorites-grid", FavoritesGridController)

import GlobalDiceController from "./global_dice_controller"
application.register("global-dice", GlobalDiceController)

import GridController from "./grid_controller"
application.register("grid", GridController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)

import HelpController from "./help_controller"
application.register("help", HelpController)

import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
application.register("keyboard-shortcuts", KeyboardShortcutsController)

import LayoutWidthController from "./layout_width_controller"
application.register("layout-width", LayoutWidthController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import VueBridgeController from "./vue_bridge_controller"
application.register("vue-bridge", VueBridgeController)

import WindowManagerController from "./window_manager_controller"
application.register("window-manager", WindowManagerController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import SyncGridController from "./sync_grid_controller"
application.register("sync-grid", SyncGridController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToastManagerController from "./toast_manager_controller"
application.register("toast-manager", ToastManagerController)

import TranslationsGridController from "./translations_grid_controller"
application.register("translations-grid", TranslationsGridController)

import UsersGridController from "./users_grid_controller"
application.register("users-grid", UsersGridController)
